import { HeatMapChart } from '@/components/composite/Charts/HeatMapChart';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { percentFormat } from '@/hooks/format/useFormatNumber';

export const bestTimeToPostConfig = {
    minWidth: 750,
    name: {
        day: {
            engagement: 'chart.best_time_to_post.engagement_more',
            reactions: 'chart.best_time_to_post.reactions_more',
            impressions: 'chart.best_time_to_post.impressions_more'
        },
        value: {
            engagement: 'chart.best_time_to_post.engagement_less',
            reactions: 'chart.best_time_to_post.reactions_less',
            impressions: 'chart.best_time_to_post.impressions_less'
        }
    },
    noTableView: true,
    csv: true,
    id: 'best_time_to_post',
    color: {
        value: 'white'
    },
    colors: {
        light: {
            blue200: '#96D8FF',
            blue300: '#33a1ff',
            blue400: '#1a95ff',
            blue: '#0089ff'
        },
        dark: {
            blue200: '#11263F',
            blue300: '#0E3861',
            blue400: '#085BA5',
            blue: '#0089ff'
        }
    },
    legendType: 'bttp',
    tooltipTranslation: {
        filtersToken: {
            engagement: 'chart.pinterest.best_time_to_post_engagement_tooltip_chart',
            reactions: 'chart.pinterest.best_time_to_post_reactions_tooltip_chart',
            impressions: 'chart.pinterest.best_time_to_post_impressions_tooltip_chart'
        },
        values: ['date', 'day', 'value', 'count_posts']
    },
    valueFormat: {
        engagement: { ...percentFormat, maximumFractionDigits: 5 },
        reactions: {},
        impressions: {}
    },
    legendHighlightValueTranslation: {
        filtersToken: {
            engagement: 'chart.pinterest.best_time_to_post_engagement_legend_highlight',
            reactions: 'chart.pinterest.best_time_to_post_reactions_legend_highlight',
            impressions: 'chart.pinterest.best_time_to_post_impressions_legend_highlight'
        },
        values: ['date', 'day']
    },
    tooltip: 'chart.pinterest.tooltip_best_time_to_post_engagement',
    size: SIZE_FULL,
    type: 'chart',
    iconHighestValue: 'star',
    margin: { bottom: 10, left: -30 },
    breakpoints: [
        { color: 'blue200', r: 3.5 },
        { color: 'blue300', r: 7.5 },
        { color: 'blue400', r: 12.5 },
        { color: 'blue', r: 12.5 }
    ],
    defaultFilter: 'engagement',
    filters: {
        engagement: {
            title: 'chart.pinterest.best_time_to_post_engagement',
            menu: 'chart.pinterest.best_time_to_post_filter_engagement'
        },
        reactions: {
            title: 'chart.pinterest.best_time_to_post_reactions',
            menu: 'chart.pinterest.best_time_to_post_filter_reactions'
        },
        impressions: {
            title: 'chart.pinterest.best_time_to_post_impressions',
            menu: 'chart.pinterest.best_time_to_post_filter_impressions'
        }
    },
    element: HeatMapChart
};
